import {Component, effect, OnDestroy, OnInit, Signal} from '@angular/core';

import {RouterModule} from '@angular/router';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faLink} from '@fortawesome/free-solid-svg-icons';
import {ShoppingService} from '../../services/shopping/shopping.service';
import {Context} from '../../models/context';
import {ContextService} from '../../services/context/context-signal.service';
import {UiButtonComponent} from "../../shared/ui";
import {PageHeaderService} from '../../services/page-header/page-header.service';
import {UiListComponent} from '../../shared/ui';
import {UiListItemComponent} from '../../shared/ui';
import {OutOfStockProductsTeaserComponent} from '../../components/out-of-stock-products-teaser/out-of-stock-products-teaser.component';
import { AppLogger, AppLoggerService } from '../../core/logging';

@Component({
  selector: 'app-shopping-list-export',
  standalone: true,
  imports: [RouterModule, FontAwesomeModule, UiButtonComponent, UiListComponent, UiListItemComponent, OutOfStockProductsTeaserComponent],
  templateUrl: './shopping-list-export.component.html',
  styleUrl: './shopping-list-export.component.scss'
})
export class ShoppingListExportComponent implements OnInit, OnDestroy {
  protected readonly context: Signal<Context> = this.contextService.context;

  private readonly log: AppLogger;

  faLink = faLink;
  protected readonly Object = Object;

  shoppingLinks: Record<string, string> = {};
  isLoading = false;
  errorMessage: string | null = null;

  constructor(
    private contextService: ContextService,
    private shoppingService: ShoppingService,
    private pageHeaderService: PageHeaderService,
    private appLogger: AppLoggerService
  ) {
    this.log = this.appLogger.createForClass(ShoppingListExportComponent);
    effect(() => {
      const c = this.context();
      if (!c?.isSet?.()) return;

      const householdId = c.household?.id;
      if (!householdId) {
        this.shoppingLinks = {};
        return;
      }

      this.loadShoppingLinks(householdId);
    });
  }

  ngOnInit(): void {
    this.pageHeaderService.setPageTitle('Shopping');
  }

  ngOnDestroy(): void {
    this.pageHeaderService.clearPageTitle();
  }

  get linksArray(): Array<{ key: string, value: string }> {
    return Object.entries(this.shoppingLinks).map(([key, value]) => ({ key, value }));
  }

  private loadShoppingLinks(householdId: number): void {
    this.isLoading = true;
    this.errorMessage = null;

    this.shoppingService.restockLinks(householdId).subscribe({
      next: (data) => {
        // HTTP returns plain objects, not Map instances, despite the service type annotation
        this.shoppingLinks = (data as any as Record<string, string>) ?? {};
        this.isLoading = false;
      },
      error: (err) => {
        this.log.error('Error loading shopping links', err, { householdId });
        this.shoppingLinks = {};
        this.isLoading = false;
        this.errorMessage = 'Could not load export links.';
      }
    });
  }

  resolveProviderAction(provider: string, link: string): string {
    if (provider === 'getbring') {
      return `https://api.getbring.com/rest/bringrecipes/deeplink?url=${link}&source=web&baseQuantity=1&requestedQuantity=1`;
    }
    return link;
  }

  // Placeholder: later you can map provider -> logo url.
  providerLogoUrl(_provider: string): string | null {

    if (_provider === 'getbring') {
      return 'assets/img/shopping-list-provider-logo/getbring.png';
    }
    return null;
  }
}
